// Web Component: MainCollection
// Gestisce il caricamento dinamico della collezione prodotti e dei filtri tramite AJAX.
// Attributi accettati:
//   - data-count: numero di prodotti che corrispondono ai filtri correnti (collection.products_count)
// Dipendenze: Utils, axios
// Limiti: richiede struttura HTML compatibile e presenza di eventi custom
// Utilizzato nelle pagine collezione per aggiornare prodotti e filtri senza ricaricare la pagina
class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init = () => {
    window.addEventListener(Utils.E_FILTER_CHANGE, (event) => {
      this.reload(event.detail.url);
    });
  }

  reload = (url) => {
    axios.get(url).then((response) => {
      const doc = Utils.getDocument(response.data);
      const collection = doc.querySelector('main-collection');
      const old_filters = document.querySelector('collection-filter');
      const new_filters = doc.querySelector('collection-filter');
      if(collection) {
        this.innerHTML = collection.innerHTML;
        this.dataset.count = collection.dataset.count;
        this.syncResultsCount(collection.dataset.count);
      }
      if(old_filters && new_filters){
        const opened = old_filters.querySelector('.accordion-collapse.show');
        const toShow = opened ? new_filters.querySelector(`#${opened.id}`) : null;
        if(toShow) {
          toShow.classList.add('show');
        }
        old_filters.innerHTML = new_filters.innerHTML;
        old_filters.init();
      }
      window.history.replaceState({}, '', url);
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'collection-reload',
        error: error,
        type: 'axios'
      });
    });
  }

  // Propaga il conteggio dei risultati filtrati ai nodi [data-results-count] che stanno fuori
  // dalla porzione di DOM rimpiazzata dal reload (es. la CTA mobile "Filtra e ordina").
  // La CTA in fondo al pannello filtri non passa da qui: sta dentro <collection-filter> ed e'
  // gia' rigenerata lato server dallo swap dell'innerHTML.
  syncResultsCount = (count) => {
    if(count == undefined) {
      return;
    }
    document.querySelectorAll('[data-results-count]').forEach((el) => {
      el.textContent = `(${count})`;
    });
  }
}
if(!customElements.get('main-collection')) {
  customElements.define('main-collection', MainCollection);
}

// Web Component: CollectionFilter
// Gestisce i filtri della collezione con input checkbox, slider di prezzo e aggiorna i prodotti tramite AJAX.
// Attributi accettati:
//   - data-url: URL base per il caricamento dei prodotti filtrati
// Eventi emessi:
//   - Utils.E_FILTER_CHANGE: emesso al cambio di un filtro con dettagli della modifica
// Dipendenze: Utils, axios, theme-slider, Shopify.analytics
// Limiti: richiede struttura HTML compatibile con form e input specifici
// Utilizzo: usato nella pagina collezione per gestire filtri prodotti
class CollectionFilter extends HTMLElement {
  form; inputs; sliders; collapses;

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.form = this.querySelector('form');
    this.inputs = this.querySelectorAll('input');
    this.sliders = this.querySelectorAll('theme-slider');
    this.inputs.forEach(input => {
      input.addEventListener('change', () => this.onChange(input));
    });
    this.sliders.forEach(slider => {
      slider.addEventListener(Utils.E_SLIDER_CHANGE, () => this.onChange(slider));
    });
  }

  onChange = (input) => {
    const data = new FormData(this.form);
    const queryString = new URLSearchParams(data).toString();
    const url = this.dataset.url + '?' + queryString;
    const detail = {
      url: url,
      change: []
    };
    if(input.tagName == 'THEME-SLIDER') {
      const value = []
      input.getInputs().forEach(input => {
        value.push(input.value);
      });
      detail.change.push({name: 'filter.v.price', value: value.join('-')});

    } else {
      detail.change.push({name: input.name, value: input.value});
    }
    window.dispatchEvent(new CustomEvent(Utils.E_FILTER_CHANGE, { detail: detail }));
    if(input.type == 'checkbox' && !input.checked)
      return;
    Shopify.analytics.publish(Utils.E_FILTER_CHANGE, detail);
  }

  showCollapse = (id) => {
    const element = document.getElementById(id);
    if(!element) {
      return;
    }
    const collapse = bootstrap.Collapse.getInstance(element) || new bootstrap.Collapse(element);
    if(collapse) {
      collapse.show();
    }
  }
}
if(!customElements.get('collection-filter')) {
  customElements.define('collection-filter', CollectionFilter);
}

// Web Component: FilterButton
// Pulsante che apre/chiude i collassabili dei filtri della collezione.
// Attributi accettati:
//   - data-open: id del collassabile da aprire/chiudere
// Eventi emessi: nessuno
// Dipendenze: collection-filter, bootstrap Collapse
// Limiti: richiede che il collassabile esista nella pagina
// Utilizzo: usato come pulsante per mostrare/nascondere i filtri su mobile
class FilterButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => this.onClick());
  }

  onClick = () => {
    const filter = document.querySelector('collection-filter');
    filter.showCollapse(this.dataset.open);
  }
}
if(!customElements.get('filter-button')) {
  customElements.define('filter-button', FilterButton);
}

// Web Component: CollectionHeading
// Gestisce i link di categoria/filtri rapidi nella collezione e traccia i click.
// Attributi accettati:
//   - data-collection: nome della collezione per il tracciamento
// Eventi emessi:
//   - Utils.E_PILL_CLICK: emesso al click di un filtro pill
// Dipendenze: Utils, Shopify.analytics
// Limiti: richiede struttura HTML compatibile con link figli
// Utilizzo: usato per mostrare filtri rapidi nella sezione heading collezione
class CollectionHeading extends HTMLElement {
  links;

  connectedCallback() {
    this.links = this.querySelectorAll('a');
    this.init();
  }

  init = () => {
    this.links.forEach((el) => {
      el.addEventListener('click', () => {
        const data = {
          label: el.innerText,
          collection: this.dataset.collection
        };
        Shopify.analytics.publish(Utils.E_PILL_CLICK, data);
        window.dispatchEvent(new CustomEvent(Utils.E_PILL_CLICK, { detail: data }));
      });
    });
  }
}
if(!customElements.get('collection-heading')) {
  customElements.define('collection-heading', CollectionHeading);
}